module.exports = __webpack_public_path__ + "static/media/about_cartkit_362_362.11f21790.png";